import { createUrl } from "@touchtech/web-api-client";

import { getEnvValue } from "@is/utils/env";

const baseUrl = getEnvValue("VITE_INSTORE_CLOUD_SERVICE_URL");

export const createContentStylesUrl = () =>
  createUrl(baseUrl, "api/content/styles");

export const createPreferencesUrl = () =>
  createUrl(baseUrl, "api/instore/Styles/preferences-v2");

export const createPreferenceForCategoriesUrl = () =>
  createUrl(baseUrl, "api/instore/Styles/preferences-for-categories");

export const createOrderCheckoutUrl = () =>
  createUrl(baseUrl, "api/instore/orders/v2");

export const createSearchRegionsUrl = (params: {
  countryCode: string;
  zipCode: string;
}) => createUrl(baseUrl, "api/instore/orders/regions/search", params);

export const createCheckoutOrderConfirmUrl = (sessionId: string) =>
  createUrl(baseUrl, `api/orders/checkouts/sessions/${sessionId}/confirm`);

export const createSignUpUrl = () => createUrl(baseUrl, "api/instore/loyalty");
